import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { PatientListService } from '../../patient-list/patient-list-service';
import * as moment from 'moment';


@Component({
  selector: 'app-patient-edit-dialog',
  templateUrl: './patient-edit-dialog.component.html',
  styleUrls: ['./patient-edit-dialog.component.css']
})
export class PatientEditDialogComponent implements OnInit {

  model: any = {
    censusIdRef: null,
    last_room_num: null,
    lastAdmitDate: moment().toDate(),
    payerName: null,
    primaryPractitionerFirstName: null,
    primaryPractitionerLastName: null,
    primaryPractitionerFullName: null,
    wingNum:null,
    source:null
  }

  minDate = new Date(1900, 0, 1);
  maxDate = new Date();
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _patientService: PatientListService,
    private _toastr: ToastrService,
    public dialogRef: MatDialogRef<PatientEditDialogComponent>,
  ) {
    this.model.patientId = this.data._id;
    this.model.censusIdRef = this.data.censusIdRef;
    this.model.lastAdmitDate = this.data?.last_admit_date;
    this.model.payerName = this.data?.non_pcc_payerName;
    this.model.primaryPractitionerFirstName = this.data.primary_practitioner_first_name;
    this.model.primaryPractitionerLastName = this.data.primary_practitioner_last_name;
    this.model.primaryPractitionerFullName=this.model.primaryPractitionerFirstName+' '+this.model.primaryPractitionerLastName;
    this.model.source=this.data.source;
    console.log("this.data : ", this.data);
    if(this.data.source=='MatrixCare'){
      this.model.roomNo = this.data.last_room_num;
      this.model.wingNum=this.data?.matrix_payload?.facility_id_pointOfCare;
      if (data && data.matrix_payload?.coverages?.length > 0) {
        let payor = ''
        for (let i = 0; i < data.matrix_payload.coverages.length; i++) {
          if (data.matrix_payload.coverages[i].insurance_type == 'primary') {
            payor = data.matrix_payload.coverages[i].insurance_company_name;
          }
          if (payor) this.model.payerName = payor;
        }
        if (!payor) {
          this.model.payerName = data.matrix_payload.coverages[0].insurance_company_name
        }
      }
      else if (data && data.insurances) {
        this.model.payerName = data.insurances.p_insurance_carrier
      }
      else {
        this.model.payerName = '';
      }
    }
    else 
    if (this.data.non_pcc_payload) {
      this.model.roomNo = this.data.non_pcc_payload.room_no;
    }
  }

  ngOnInit(): void {
    console.log("asdfsdf", this.data);
  }
  getLastName(str) {
    const indexOfSpace = str.indexOf(' ');
    if (indexOfSpace === -1) {
      return '';
    }
    return str.substring(indexOfSpace + 1);
  }
  
  updatePatient() {
    this.model.primaryPractitionerFirstName = this.model.primaryPractitionerFullName.split(' ')[0];
    let lastName = this.getLastName(this.model.primaryPractitionerFullName);
    this.model.primaryPractitionerLastName = lastName;

    if(!(this.data.source=='MatrixCare')){
      delete this.model.source;
      delete this.model.wingNum;
    }
    this._patientService.updatePatient(this.model).subscribe((response: any) => {
      console.log(response);
      if (response.status === 200) {
        this.dialogRef.close(response.data);
        this._toastr.success('Patient status updated successfully')
      }
    });
  }
}
